var _path, _g, _g2, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    fill: "#ee1c25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h900v600H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.936 125.196a27.917 27.917 0 0 0-14.902 41.792 45.171 45.171 0 0 1-20.29 66.204 38.65 38.65 0 0 0-10.816 64.313 68.375 68.375 0 0 1-17.068-93.914 15.81 15.81 0 0 1-1.109-1.047 69.88 69.88 0 0 0 16.755 95.793 90.342 90.342 0 0 1 47.43-173.141",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.98 181.1-27.565 12.021 29.366 6.476-19.951-22.5 2.915 29.93"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72 450 300)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(216 450 300)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72 450 300)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHk);
export default __webpack_public_path__ + "static/media/hk.3eac96bf96ffae95f24ec8afe5a6b412.svg";
export { ForwardRef as ReactComponent };